import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { ScoUser } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const ScoUserSEO = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.user.bio || $[1] !== props.user.displayName || $[2] !== props.user.fullName || $[3] !== props.user.shortBio) {
    const seoProps = {};
    seoProps.title = `Member: ${props.user.fullName || props.user.displayName}`;
    seoProps.description = props.user.shortBio || props.user.bio;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = props.user.bio;
    $[1] = props.user.displayName;
    $[2] = props.user.fullName;
    $[3] = props.user.shortBio;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
ScoUserSEO.fragments = {
  ScoUser: () => gql`
    fragment _ on ScoUser {
      id
      fullName
      displayName
      bio
      shortBio
    }
  `
};